import React from 'react';

interface Props {
  label: string;
  value: string | number;
  color?: 'blue'|'teal'|'green'|'red'|'orange'|'gray'|'purple'|'amber'|'slate'|'pink'|'indigo'|'cyan';
  sub?: string;
  trend?: number;
  icon?: string;
}

const COLORS: Record<string, { border: string; text: string; iconBg: string }> = {
  blue:   { border: '#02357A', text: '#02357A', iconBg: 'bg-[#02357A]'   },
  teal:   { border: '#039089', text: '#039089', iconBg: 'bg-[#039089]'   },
  green:  { border: '#16a34a', text: '#15803d', iconBg: 'bg-green-600'   },
  red:    { border: '#dc2626', text: '#b91c1c', iconBg: 'bg-red-600'     },
  orange: { border: '#ea580c', text: '#c2410c', iconBg: 'bg-orange-600'  },
  purple: { border: '#7c3aed', text: '#6d28d9', iconBg: 'bg-purple-600'  },
  amber:  { border: '#d97706', text: '#b45309', iconBg: 'bg-amber-500'   },
  slate:  { border: '#576478', text: '#576478', iconBg: 'bg-[#576478]'   },
  gray:   { border: '#576478', text: '#576478', iconBg: 'bg-[#576478]'   },
  pink:   { border: '#db2777', text: '#be185d', iconBg: 'bg-pink-600'    },
  indigo: { border: '#4338ca', text: '#3730a3', iconBg: 'bg-indigo-600'  },
  cyan:   { border: '#0891b2', text: '#0e7490', iconBg: 'bg-cyan-600'    },
};

export default function StatCard({ label, value, color = 'blue', sub, trend, icon }: Props) {
  const c = COLORS[color] ?? COLORS.blue;
  return (
    <div className="bg-white rounded-xl shadow-sm border overflow-hidden"
      style={{ borderLeft: `4px solid ${c.border}` }}>
      <div className="p-4">
        <div className="flex items-start justify-between">
          <div className="flex-1 min-w-0">
            <p className="text-xs font-semibold uppercase tracking-wide text-gray-500 truncate">{label}</p>
            <p className="text-2xl font-bold mt-1 truncate" style={{ color: c.text }}>{value ?? '—'}</p>
            {sub && <p className="text-xs text-gray-400 mt-0.5 truncate">{sub}</p>}
            {trend !== undefined && (
              <p className={`text-xs font-medium mt-1 ${trend >= 0 ? 'text-green-600' : 'text-red-500'}`}>
                {trend >= 0 ? '↑' : '↓'} {Math.abs(trend)}% vs last month
              </p>
            )}
          </div>
          {icon && (
            <div className={`w-10 h-10 rounded-xl flex items-center justify-center text-white text-lg flex-shrink-0 ml-3 ${c.iconBg}`}>
              {icon}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
